/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getStockAvailDateJsonAsync } from './DataService/DataActionExtension.g';
import { ICalculateStockAvailDateJsonResponse } from './DataService/DataServiceEntities.g';
/**
 * GetstockavaildateJson Input Action
 */
export class GetStockAvailDateJsonInput implements IActionInput {
    // TODO: Construct the input needed to run the action
    public accountNum: number;
    public catalogId: number;
    public itemId: string;
    public dispositionCode: string;
    public quantity: number;
    public userName: string;

    constructor(
        accountNum: number | string,
        catalogId: number | string,
        itemId: string,
        dispositionCode: string,
        quantity: number | string,
        userName: string
    ) {
        this.accountNum = typeof accountNum === 'string' ? +accountNum : accountNum;
        this.catalogId = typeof catalogId === 'string' ? +catalogId : catalogId;
        this.itemId = itemId;
        this.dispositionCode = dispositionCode;
        this.quantity = typeof quantity === 'string' ? +quantity : quantity;
        this.userName = userName;
    }
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetStockAvailDateJsonInput`;
    public getCacheObjectType = () => 'GetStockAvailDateJsonInput';
    public dataCacheType = (): CacheType => 'none';
}

// // TODO: Create a data model here or import one to capture the response of the action
// export interface IGetstockavaildateJsonData {
//     text: string;
// }

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
    args: ICreateActionContext,
    accountNum: number | string,
    catalogId: number | string,
    itemId: string,
    dispositionCode: string,
    quantity: number | string,
    userName: string
): IActionInput => {
    return new GetStockAvailDateJsonInput(accountNum, catalogId, itemId, dispositionCode, quantity, userName);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function GetStockAvailDateJson(
    input: GetStockAvailDateJsonInput,
    ctx: IActionContext
): Promise<ICalculateStockAvailDateJsonResponse> {
    return getStockAvailDateJsonAsync(
        { callerContext: ctx },
        input.itemId,
        input.quantity,
        input.accountNum,
        input.catalogId,
        input.dispositionCode,
        input.userName
    )
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-warehouse-stock-avail-qty] Unable to load warehouse list');
            throw new Error('[get-warehouse-stock-avail-qty] Unable to load warehouse list');
        });
}

export default createObservableDataAction({
    action: <IAction<ICalculateStockAvailDateJsonResponse>>GetStockAvailDateJson,
    // TODO: Give your data action a unique id
    id: 'GetStockAvailDateJson',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
